import { fg } from '@atlassian/jira-feature-gating';

const JiraAiAgentTeamSessionsEnabledRelayProvider = {
	get(): boolean {
		return fg('jira-ai-read-agent-sessions');
	},
};

export default JiraAiAgentTeamSessionsEnabledRelayProvider;
